import * as types from '@/constants/mutationTypes';

const state = {
  mainScroll: false
};
const getters = {
  mainScroll: (state) => state.mainScroll
};
const actions = {
  setMainScroll ({ commit }, data) {
    commit(types.SET_MAIN_SCROLL, { data });
  }
};
const mutations = {
  [types.SET_MAIN_SCROLL] (state, { data }) {
    state.mainScroll = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
